import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/bundle';
import React, { useState } from 'react';
import Header from './Header_Transparent_Base';
import HeaderWhite from './Header_White_Base';
import Footer from './Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../common/css/Main2.css';
import { Mousewheel, Pagination, Autoplay, EffectFade, Zoom } from 'swiper/modules';
import Main1 from './img/sotec_img_bg_1.png'
import Main2 from './img/sotec_img_bg_3.png'
import Main3 from './img/sotec_img_bg_2.png'
import Solution1 from './img/sotec_img_design_home.png'
import Solution2 from './img/sotec_img_programming_home-1.png'
import Solution3 from './img/sotec_img_quality-1.png'
import Silde3 from './img/Main4.png'
import { Link } from 'react-router-dom';
import 'swiper/css/pagination';
import Text from './Text'



function Main() {
  const [swiper, setSwiper] = useState(null);
  const [IsChange, setIsChange] = useState(false);
  // const HeaderComponent = IsChange ? HeaderWhite : Header
  const HeaderComponent = HeaderWhite; // 헤더 파일 하나로 통일
  const FooterStyle = {
    textAlign: 'left',
    height: '250px !important',
    alignItems: 'flex-start',
    position: 'relative'
  };

  // const handleZoomChange = (swiper,scale) => {
  //   let container = {}
  //   if (IsChange) {
  //     container = document.querySelector('.menu_w');
  //   } else{
  //     container = document.querySelector('.menu');
  //   }
  //   container.style.transform = `scale(${scale})`; // 줌 레벨에 따라 스케일을 조정합니다.
  //   console.log('현재 scale 값:', scale);
  // };

  return (
    <div className='zoom-container' style={{ height: '100%' }}>
      <HeaderComponent name={'MainPage'} isWhiteBack={IsChange} />
      <div style={{ height: '100%', position: 'relative', width: '100%' }}>
        <Swiper
          initialSlide={0}
          direction={'vertical'}
          slidesPerView={'auto'}
          mousewheel={true}
          autoHeight={true}
          speed={1000}
          touchRatio={1}
          zoom={{ maxRatio: 2, minRatio: 1 }}
          modules={[Mousewheel, Pagination]}
          onSwiper={setSwiper}
          // onZoomChange={handleZoomChange}
          onTransitionStart={() => {
            console.log(swiper.progress);
            if (swiper.realIndex == 1) { setIsChange(true) }
            else if (swiper.progress == 1) { setIsChange(true) }
            else { setIsChange(false) }
          }}
        >
          <SwiperSlide style={{ position: 'relative' }}>
            <Swiper direction={'horizontal'}
              slidesPerView={'auto'}
              className='MainFirstItemSwiper'
              loop={true}
              // onZoomChange={handleZoomChange}
              speed={2000}
              mousewheel={false}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              modules={[Autoplay, Pagination, EffectFade]}
              pagination={{ clickable: true }}
              effect={'fade'}
              zoom={{ maxRatio: 2, minRatio: 1 }}
              touchRatio={1}

            >

              {/* <SwiperSlide className='swiper_min_H_W swiper-zoom-container'> */}
              <SwiperSlide>
                <div className='Mainimg' style={{ zIndex: 0, backgroundImage: `url(${Main1})` }}>
                  <div className='maintext2'>
                    <Text variant='px48w600' className={'mainSideText_First'}>S<Text variant='px40w100' className={'mainSideText_Other'}>olution</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>O<Text variant='px40w100' className={'mainSideText_Other'}>utstanding</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>T<Text variant='px40w100' className={'mainSideText_Other'}>rust</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>E<Text variant='px40w100' className={'mainSideText_Other'}>xpertise</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>C<Text variant='px40w100' className={'mainSideText_Other'}>hallenge</Text></Text>
                  </div>
                  <div className='maintext2_1'>
                    <Text variant='px60w600' className={'mainRightSideText'}>정확<Text variant='px60w200' className={'mainRightSideText'}>하고 <Text variant='px60w600' className={'mainRightSideText'}>안전<Text variant='px60w200' className={'mainRightSideText'}>한</Text></Text></Text></Text>
                    <Text variant='px60w600' className={'mainRightSideText'}>솔루션<Text variant='px60w200' className={'mainRightSideText'}>을 제공합니다</Text></Text>
                  </div>
                </div>
                {/* </div>
                  </div> */}
              </SwiperSlide>
              {/* <SwiperSlide className='swiper_min_H_W swiper-zoom-container'> */}
              <SwiperSlide>
                {/* <div className='swiper-zoom-container'>
                    <div className='swiper-zoom-target'> */}
                <div className='Mainimg' style={{ zIndex: 0, backgroundImage: `url(${Main3})` }} >
                  <div className='maintext2'>
                    <Text variant='px48w600' className={'mainSideText_First'}>S<Text variant='px40w100' className={'mainSideText_Other'}>olution</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>O<Text variant='px40w100' className={'mainSideText_Other'}>utstanding</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>T<Text variant='px40w100' className={'mainSideText_Other'}>rust</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>E<Text variant='px40w100' className={'mainSideText_Other'}>xpertise</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>C<Text variant='px40w100' className={'mainSideText_Other'}>hallenge</Text></Text>
                  </div>
                  <div className='maintext2_1'>
                    <Text variant='px60w600' className={'mainRightSideText'}>성장<Text variant='px60w200' className={'mainRightSideText'}>과 <Text variant='px60w600' className={'mainRightSideText'}>성취<Text variant='px60w200' className={'mainRightSideText'}>를 위해</Text></Text></Text></Text>
                    <Text variant='px60w200' className={'mainRightSideText'}>끊임없이 <Text variant='px60w600' className={'mainRightSideText'}>도전<Text variant='px60w200' className={'mainRightSideText'}>합니다</Text></Text></Text>
                  </div>
                </div>
                {/* </div>
                  </div> */}
              </SwiperSlide>
              {/* <SwiperSlide className='swiper_min_H_W swiper-zoom-container'> */}
              <SwiperSlide>
                {/* <div className='swiper-zoom-container'>
                    <div className='swiper-zoom-target'> */}
                <div className='Mainimg' style={{ zIndex: 0, backgroundImage: `url(${Main2})` }} >
                  <div className='maintext2'>
                    <Text variant='px48w600' className={'mainSideText_First'}>S<Text variant='px40w100' className={'mainSideText_Other'}>olution</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>O<Text variant='px40w100' className={'mainSideText_Other'}>utstanding</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>T<Text variant='px40w100' className={'mainSideText_Other'}>rust</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>E<Text variant='px40w100' className={'mainSideText_Other'}>xpertise</Text></Text>
                    <Text variant='px48w600' className={'mainSideText_First'}>C<Text variant='px40w100' className={'mainSideText_Other'}>hallenge</Text></Text>
                  </div>
                  <div className='maintext2_1'>
                    <Text variant='px60w600' className={'mainRightSideText'}>혁신<Text variant='px60w200' className={'mainRightSideText'}>적인 <Text variant='px60w600' className={'mainRightSideText'}>기술<Text variant='px60w200' className={'mainRightSideText'}>로</Text></Text></Text></Text>
                    <Text variant='px60w600' className={'mainRightSideText'}>조선·해양 <Text variant='px60w200' className={'mainRightSideText'}>산업을 <Text variant='px60w600' className={'mainRightSideText'}>선도<Text variant='px60w200' className={'mainRightSideText'}>합니다</Text></Text></Text></Text>
                  </div>
                </div>
                {/* </div>
                  </div> */}
              </SwiperSlide>
            </Swiper>
          </SwiperSlide>

          <SwiperSlide className='swiper_min_H_W swiper-zoom-container' >
            {/* <div className='swiper-zoom-container'>
                <div className='swiper-zoom-target'> */}
            <div style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '100%' }}>
              {/* 왼쪽 여백 */}
              {/* <div style={{ width: '268px' }}></div>  */}
              {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60%' }}> */}
              <div style={{ paddingTop: '60px' }}></div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto', height: 'calc(100% - 100px)' }}>
                <Text variant='px34w700' className={'main_business_title'} >기술 혁신으로 글로벌 조선,해양 산업을 선도하는 기업</Text>
                <div className='main2_card' >

                  <Swiper className='mainBusiness_swiper'
                    // modules={[Pagination]}
                    // navigation={true} 
                    // pagination={{ clickable: true }}
                    spaceBetween={20}
                    loop={true}
                    breakpoints={{
                      0: {
                        slidesPerView: 1.4,
                        centeredSlides: true
                      },
                      769: {
                        slidesPerView: 3,
                        centeredSlides: false
                      },
                    }}

                  >

                    <SwiperSlide>
                      <Link to="/Building"  state={{data : 'B' }} className='Solution' style={{ backgroundColor: 'black', position: 'relative' }}>
                        <img src={Solution1} alt='' style={{ Width: '360px', height: 'auto', opacity: '0.5', height: '100%' }} />
                        <div style={{
                          position: 'absolute',
                          top: '20%',
                          left: '0%',
                          color: 'white',
                          textAlign: 'center',
                          zIndex: 1,
                          whiteSpace: 'nowrap',
                          width: '100%'
                        }}>
                          <Text variant='px30w700' className='mainBusiness_title' style={{ marginBottom: '20px', display: 'block' }}>설계</Text>
                          <Text variant='px20w400' style={{ color: '#ffffff', display: 'block' }}>조선해양산업의 미래를 설계하는<br />정밀 엔지니어링 기술</Text>
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ width: '72px', height: '72px', fontSize: '16px', fontWeight: '200', lineHeight: '18px', borderRadius: '36px', justifyContent: 'center', display: 'flex', alignItems: 'center', border: '1px solid white', marginTop: '15px' }}>Enter</div></div>
                        </div>
                      </Link>
                    </SwiperSlide>

                    <SwiperSlide>
                      <Link to='/Building'  state={{data : 'I'}} className='Solution' style={{ backgroundColor: 'black', position: 'relative' }}>
                        <img src={Solution2} alt='' style={{ maxWidth: '100%', height: 'auto', opacity: '0.5', height: '100%' }} />
                        <div style={{
                          position: 'absolute',
                          top: '20%',
                          left: '0%',
                          color: 'white',
                          textAlign: 'center',
                          zIndex: 1,
                          whiteSpace: 'nowrap',
                          width: '100%'
                        }}>
                          <Text variant='px30w700' className='mainBusiness_title' style={{ marginBottom: '20px', display: 'block' }}>시스템 개발</Text>
                          <Text variant='px20w400' style={{ color: '#ffffff', display: 'block' }}>조선해양산업의 혁신을<br /> 주도하는 첨단 스마트 기술 솔루션</Text>
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ width: '72px', height: '72px', fontSize: '16px', fontWeight: '200', lineHeight: '18px', borderRadius: '36px', justifyContent: 'center', display: 'flex', alignItems: 'center', border: '1px solid white', marginTop: '15px' }}>Enter</div></div>
                        </div>
                      </Link>
                    </SwiperSlide>

                    <SwiperSlide>
                      <Link to='/Building?source=effect2'  state={{data: 'Q'}} className='Solution' style={{ backgroundColor: 'black', position: 'relative' }}>
                        <img src={Solution3} alt='' style={{ maxWidth: '100%', height: 'auto', opacity: '0.5', height: '100%' }} />
                        <div style={{
                          position: 'absolute',
                          top: '20%',
                          left: '0%',
                          color: 'white',
                          textAlign: 'center',
                          zIndex: 1,
                          whiteSpace: 'nowrap',
                          width: '100%'
                        }}>
                          <Text variant='px30w700' className='mainBusiness_title' style={{ marginBottom: '20px', display: 'block' }}>품질 검사 <br /></Text>
                          <Text variant='px20w400' style={{ color: '#ffffff', display: 'block' }}>조선해양산업의 품질을<br /> 책임지는 관리 파트너</Text>
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ width: '72px', height: '72px', fontSize: '16px', fontWeight: '200', lineHeight: '18px', borderRadius: '36px', justifyContent: 'center', display: 'flex', alignItems: 'center', border: '1px solid white', marginTop: '15px' }}>Enter</div></div>
                        </div>
                      </Link>
                    </SwiperSlide>

                  </Swiper>
                </div>
              </div>
              {/* 오른쪽 여백 */}
              {/* <div style={{ width: '268px' }}></div>  */}
            </div>
            {/* </div>
              </div> */}
          </SwiperSlide>


          <SwiperSlide className='swiper_min_H_W' style={{ backgroundColor: 'rgba(5, 4, 40)' }}>
            {/* <div className='swiper-zoom-container'>
                  <div className='swiper-zoom-target'> */}
            <div className='main_content3_back' style={{ backgroundImage: `url(${Silde3})` }}>

              <div id='content3_title_container'>
                <div>
                  <span className='main_content3_up_text'>더 나은 <span className='main_content3_up_text_bold'> 미래,</span></span>
                </div>
                <div>
                  <span className='main_content3_up_text_bold'>함께 <span className='main_content3_up_text'> 함으로써 실현되는 </span><span className='main_content3_up_text_bold'> 오늘</span></span>
                </div>
              </div>

              <div id='content3_item_container'>
                <Swiper className='mainContent3_swiper'
                  // modules={[Pagination]}
                  // navigation={true} 
                  // pagination={{ clickable: true }}
                  spaceBetween={20}
                  loop={true}
                  breakpoints={{
                    0: {
                      slidesPerView: 1.4,
                      centeredSlides: true
                    },
                    769: {
                      slidesPerView: 3,
                      centeredSlides: false
                    },
                  }}

                >
                  <SwiperSlide>
                    <div className='content3_itembox'>
                      <Link to='/PersonnelSystem' style={{ textDecoration: 'none' }}>
                        <Text variant='px16w400' className='content3_item_moreview' >More view</Text>
                        <Text variant='px36w700' className='content3_item_subtitle' >인사 제도</Text>
                        <Text variant='px16w400' className='content3_item_subtext' >SOTEC의 직책 체계와<br />연봉체계 및 다양한<br />복지를 알 수 있습니다.</Text>
                      </Link>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className='content3_itembox'>
                      <Link to='/Vision' style={{ textDecoration: 'none' }}>
                        <Text variant='px16w400' className='content3_item_moreview' >More view</Text>
                        <Text variant='px36w700' className='content3_item_subtitle' >경영 비전</Text>
                        <Text variant='px16w400' className='content3_item_subtext' >Sollution, Oriented,<br />Trust, Expertise,<br />Challenge</Text>
                      </Link>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className='content3_itembox'>
                      <Link to='/RecruitmentCard' style={{ textDecoration: 'none' }}>
                        <Text variant='px16w400' className='content3_item_moreview' >More view</Text>
                        <Text variant='px36w700' className='content3_item_subtitle' >채용 공고</Text>
                        <Text variant='px16w400' className='content3_item_subtext' >SOTEC와 함께하실<br />여러분들을 응원합니다.</Text>
                      </Link>
                    </div>
                  </SwiperSlide>

                </Swiper>


              </div>

            </div>

          </SwiperSlide>


          <SwiperSlide style={FooterStyle} >
            {/* <div className='swiper-zoom-container' style={{maxHeight:'250px',minHeight:'250px'}}>
                <div className='swiper-zoom-target' style={{maxHeight:'250px',minHeight:'250px',textAlign:'left',alignItems:'flex-start',position:'relative'}}> */}
            <Footer />
            {/* </div>
              </div> */}
          </SwiperSlide>
        </Swiper>
      </div >




    </div >
  );
}

export default Main;